import {BannerDataNull} from '@core-client/ads/banner/data/BannerDataNull';

import {BannerRenderer} from './BannerRenderer';

export class NullBannerRenderer extends BannerRenderer {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    showBannerDiv(banner: BannerDataNull) {
        this.bannerView.hideContainer();
        this.bannerView.container.innerHTML = '';
    }
}
